module.exports = __webpack_public_path__ + "img/search_featured.69631fe4.svg";